import React from "react";
import { useTranslation } from 'react-i18next';

import { getFullName } from "../models/User";
import { OrganizationChartData } from "../models/Hierarchy";

export interface OrganizationChartTemplateProps {
    nodeData: any;
}

const _getInitials = (name: string, lastName: string | null): string => {
    const first = name?.charAt(0)?.toUpperCase() ?? '';
    const last = lastName?.charAt(0)?.toUpperCase() ?? '';
    return `${first}${last}`;
};

const OrganizationChartTemplate = (props: OrganizationChartTemplateProps) => {

    const [t] = useTranslation();
    const organizationChart: OrganizationChartData = props.nodeData;
    const { name, last_name, email, rol } = organizationChart.data;

    const roles: string[] = rol?.map((r: string) => t(`rol_${r}`)) ?? [];
    const initials = _getInitials(name, last_name);

    return (
        <div className="oc-node-card">
            <div className="oc-node-card__header">
                <div className="oc-node-card__avatar">
                    {initials}
                </div>
                <div className="oc-node-card__info">
                    <div className="oc-node-card__name">{getFullName(organizationChart.data)}</div>
                    <div className="oc-node-card__email">{email}</div>
                </div>
            </div>
            {roles.length > 0 && (
                <div className="oc-node-card__roles">
                    {roles.map((role, index) => (
                        <span key={index} className="oc-node-card__role-badge">{role}</span>
                    ))}
                </div>
            )}
            <i className="oc-edge verticalEdge bottomEdge oci" />
        </div>
    );

}

export default React.memo(OrganizationChartTemplate);
